import {get, post} from '../utils/api';
export const FETCH_SEARCH_BEGIN = 'FETCH_SEARCH_BEGIN';
export const FETCH_SEARCH_DATA_SUCCESS = 'FETCH_SEARCH_DATA_SUCCESS';
export const FETCH_SEARCH_SUCCESS = 'FETCH_SEARCH_SUCCESS';
export const FETCH_SEARCH_RESULTS_BEGIN = 'FETCH_SEARCH_RESULTS_BEGIN';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_FAILURE = 'FETCH_SEARCH_FAILURE';
export const ADD_SEARCH_CHIP = 'ADD_SEARCH_CHIP';
export const REMOVE_SEARCH_CHIP = 'REMOVE_SEARCH_CHIP';
export const REMOVE_LAST_SEARCH_CHIP = 'REMOVE_LAST_SEARCH_CHIP';
export const ADD_SEARCH_CHIPS = 'ADD_SEARCH_CHIPS';
export const CLEAR_SEARCH_CHIPS = 'CLEAR_SEARCH_CHIPS';
export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const STORE_SEARCH_FILTER = 'STORE_SEARCH_FILTER';
export const CLEAR_SEARCH_FILTER = 'CLEAR_SEARCH_FILTER';
export const FETCH_JIRA_UNITS_BEGINS = 'FETCH_JIRA_UNITS_BEGINS';
export const FETCH_JIRA_UNITS_SUCCESS = 'FETCH_JIRA_UNITS_SUCCESS';
export const GET_FILTER = 'GET_FILTER';

export const fetchSearchBegin = () => ({
    type: FETCH_SEARCH_BEGIN
});

export const fetchSearchSuccess = result => ({
    type: FETCH_SEARCH_SUCCESS,
    payload: result
});

export const fetchSearchResultsBegin = result => ({
    type: FETCH_SEARCH_RESULTS_BEGIN,
    payload: result
});

export const fetchSearchResultsSuccess = result => ({
    type: FETCH_SEARCH_RESULTS_SUCCESS,
    payload: result
});

export const fetchSearchDataSuccess = result => ({
    type: FETCH_SEARCH_DATA_SUCCESS,
    payload: result
});
export const fetchJiraUnits = result => ({
    type: FETCH_JIRA_UNITS_BEGINS,
    payload: result
});
export const fetchJiraUnitsSuccess = result => ({
    type: FETCH_JIRA_UNITS_SUCCESS,
    payload: result
});

export const addSearchChip = valueObj => ({
    type: ADD_SEARCH_CHIP,
    payload: valueObj
});

export const addSearchChips = obj => ({
    type: ADD_SEARCH_CHIPS,
    payload: obj
});

export const removeSearchChip = idx => ({
    type: REMOVE_SEARCH_CHIP,
    payload: idx
});

export const removeLastChip = () => ({
    type: REMOVE_LAST_SEARCH_CHIP
});

export const clearSearchChips = () => ({
    type: CLEAR_SEARCH_CHIPS,
    payload: []
});

export const getFilter = result => ({
    type: GET_FILTER,
    payload: result
});

export const storeSearchFilter = result => ({
    type: STORE_SEARCH_FILTER,
    payload: result
});

export const clearSearchFilter = () => ({
    type: CLEAR_SEARCH_FILTER
})

export function fetchSearchData() {
    return dispatch => {
        get('search/suggest').then(data => {
            dispatch(fetchSearchDataSuccess(data));
        });
    };
}

export function fetchJiraUnitsResults(page){
    return (dispatch) => {
        let url = 'manage/jira_units?page=' + page;
        dispatch(fetchJiraUnits(page));
        return get(url).then(data => {
            dispatch(fetchJiraUnitsSuccess(data));
        });
    }
}

export function fetchSearchResults(page, search_options) {
    return (dispatch, getState) => {
        let state = getState();
        let col = state.search.column;
        let dir = state.search.direction
        dispatch(fetchSearchResultsBegin(page));
        let url = 'search?' + search_options.join('&') + "&page=" + page;
        if (col && dir) {
            url += "&sort_col=" + col + '&sort_dir='+ dir;
        }
        return get(url)
            .then(data => {
            dispatch(fetchSearchResultsSuccess(data));
        });
    };
}


export function addSearchFilter(column, direct) {
    return (dispatch) => {
        dispatch(storeSearchFilter(column, direct));
    }
}
